<template>
    <div class="listOf">
        <!-- 题列表 -->
        <div shadow="hover" class="listItem xy-between" v-for="(info,i) in personList" :key="i">
            <div class="left jf auto-grow auto-scroll">
                <div class="order c-256CF4 font-size30">
                    {{info.order}}
                </div>
                <div class="throw"></div>
                <div class="info auto-scroll auto-grow">
                    <div v-if="info.SubjectName">
                        <div class="className font-size18 c-333 one-wrap" v-html="info.SubjectName"></div>
                    </div>
                    <div v-else-if="info.ViewName">
                        <div class="className font-size18 c-333 one-wrap" v-html="info.ViewName"></div>
                    </div>
                    <div>
                        <div v-if="info.SubjectName" class="topicType font-size14 c-72777">
                            <span>分类：{{info.ClassName}}</span>
                            <span class="left">题型：
                                {{info.SubjectType === "1" ?  "单选题" : info.SubjectType === "2" ? "多选题" : info.SubjectType === "3" ?
            "填空题" : info.SubjectType === "4" ? "判断题" : info.SubjectType === "5" ? "问答题" :info.SubjectType === "6" ?  "复合题" : "模拟试卷"}}</span>
                        </div>
                        <div v-else-if="info.ViewName" class="topicType font-size14 c-72777">
                            <span>分类：{{info.ClassName}}</span>
                            <span class="left">总分：{{info.TotalScore}}</span>
                            <span class="left">题量：{{info.SubjectNum}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right jf no-shrink">
                <div class="btn collect xy-center cursor font-size14 jf" @click="collection(info)">
                    <div>
                        <i v-if="!info.collect" class="el-icon-star-on font-size18 c-C3D7FD"></i>
                        <i v-else class="el-icon-star-on font-size18 c-FFD251"></i>
                    </div>
                    收藏
                </div>
                <div class="btn makeTopic xy-center cursor font-size14" @click="makeTopic(info)">
                    <span>{{type === "topic" ?"开始做题" : "开始做卷"  }} </span>
                </div>
            </div>
        </div>

        <!-- 卷列表 -->
        <div>

        </div>
        <!-- 卷列表 -->

        <!-- <div class="paging xy-center">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-size="pageSsize" layout="total, sizes, prev, pager, next, jumper"
                :total="num">
            </el-pagination>
        </div> -->
    </div>
</template>

<script>
import {
    MyCollection
} from "@/api/course"
import { ExamStatusHelper } from "@/mixins/examStatusHelper";
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: ""
        }
    },
    mixins: [ExamStatusHelper],
    created() {},
    data() {
        return {
            currentSatus: "topic",
            searchKey: "",
            pageIndex: 1,
            pageSsize: 10,
            currentDay: ""
        }
    },
    computed: {
        personList: {
            get() {
                return this.list
            },
            set(newValue) {
                this.list = newValue
            }
        }
    },
    methods: {
        getNowFormatDate() {
            var date = new Date();
            var year = date.getFullYear(); // 年 ,从 Date 对象以四位数字返回年份
            var month = date.getMonth() + 1; // 月 ,从 Date 对象返回月份 (0 ~ 11) ,date.getMonth()比实际月份少 1 个月
            var day = date.getDate(); // 日 ,从 Date 对象返回一个月中的某一天 (1 ~ 31)
            var hours = date.getHours(); // 小时 ,返回 Date 对象的小时 (0 ~ 23)
            var minutes = date.getMinutes(); // 分钟 ,返回 Date 对象的分钟 (0 ~ 59)
            var seconds = date.getSeconds(); // 秒 ,返回 Date 对象的秒数 (0 ~ 59)
            // 获取当前系统时间
            var currentDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            // 修改月份格式
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            // 修改日期格式
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            // 修改小时格式
            if (hours >= 0 && hours <= 9) {
                hours = "0" + hours;
            }
            // 修改分钟格式
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            // 修改秒格式
            if (seconds >= 0 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            // 获取当前系统时间  格式(yyyy-mm-dd hh:mm:ss)
            var currentFormatDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            this.currentDay = currentFormatDate
        },

        handleSizeChange(val) {
            this.pageSsize = val
            this.$emit("SizeChange", val)
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.$emit("CurrentChange", val)
        },
        makeTopic(info) {
            if (this.type === "topic") {
                this.$emit("saveLocalstory", info)
            } else {
                this.getNowFormatDate()
                if (this.currentDay) {
                    this.$router.push({
                        path: "/examDetail",
                        query: {
                            type: "school",
                            paperId: info.EpId,
                            scorePublish: "",
                            isCheckScore: true,
                            publishTime: "",
                            paperName: info.ViewName,
                            classId: info.EcId,
                            ClassName: info.ClassName,
                            startTime: this.currentDay,
                            examUuid: this.genExamUuidAndStartExamStatus()
                        }
                    })
                }
            }
        },
        // 收藏
        collection(val) {
            if (!val.collect) {
                this.MyCollection(val).then(res => {
                    this.$message({
                        type: "success",
                        message: "收藏成功"
                    })
                    this.personList.forEach(v => {
                        if (this.type === "topic" && v.SubjectId === val.SubjectId) {
                            v.collect = "1"
                        } else if (this.type === "paper" && v.EpId === val.EpId) {
                            v.collect = "1"
                        }
                    });
                })
            } else if (val.collect === "1") {
                this.MyCollection(val).then(res => {
                    this.$message({
                        type: "warning",
                        message: "取消收藏"
                    })
                    this.personList.forEach(v => {
                        if (this.type === "topic" && v.SubjectId === val.SubjectId) {
                            v.collect = ""
                        } else if (this.type === "paper" && v.EpId === val.EpId) {
                            v.collect = ""
                        }
                    });
                })
            }
        },
        async MyCollection(val) {
            try {
                const {
                    data
                } = await MyCollection({
                    id: val.SubjectId || val.EpId,
                    name: val.SubjectName || val.ViewName,
                    sourceType: 2,
                    type: this.type === "topic" ? 1 : 2,
                    score: this.type === "topic" ? 0 : val.TotalScore,
                    subjectType: this.type === "topic" ? val.SubjectType : "",
                    categoryName: val.ClassName,
                    classId: val.ClassId || val.EcId,
                    categoryId: "",
                    columnId: ""
                })
                return Promise.resolve()
            } catch (error) {
                this.$toast("服务器繁忙，请稍后再试！");
                return Promise.reject()
            }
        }
    }

}

</script>

<style scoped lang="less">
    .auto-scroll {
        overflow-x: auto;
    }
    .listOf {
        min-height: 600px;
        // background-color: #fff;
    }

    .listItem {
        width: 100%;
        height: 124px;
        background: #FFFFFF;
        margin-top: 1px;
        padding: 30px 40px;
        box-sizing: border-box;
        overflow-x: auto;

        .left {
            height: 100%;
            .throw {
                width: 1px;
                height: 50px;
                background: #E5E8EC;
                margin: 0 40px;
            }
        }

        .info {
            //height: 65px;

            .className {
                margin-bottom: 15px;
                height: 28px;
                ::v-deep {
                    p,ol {
                        margin-block-end: 0;
                        margin-block-start: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }

            .topicType {
                .left {
                    margin-left: 60px;
                }
            }
        }

        .right {
            margin-left: 20px;
            .btn {
                width: 98px;
                height: 36px;
                background: #EBF2FF;
                border-radius: 18px;
                color: white;
            }

            .collect {
                color: #256CF4;
                margin-right: 10px;
            }

            .makeTopic {
                background: linear-gradient(270deg, #4987FF 0%, #4CA5FA 100%);
            }
        }
    }

</style>
